module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--9--a-753c0603.png";